module.exports = __webpack_public_path__ + "static/media/cherrypicjs.7d6fbb4f.png";